<div class="graph-shell">

  <article class="panel graph-legend-panel">
    <div class="graph-legend">
      <span class="legend-item"><span class="legend-dot"
          style="background:var(--node-component)"></span>Component</span>
      <span class="legend-item"><span class="legend-dot" style="background:var(--node-failure-instance)"></span>Failure
        Instance</span>
      <span class="legend-item"><span class="legend-dot" style="background:var(--node-failure-effect)"></span>Failure
        Effect</span>
      <span class="legend-item"><span class="legend-dot" style="background:var(--node-system-effect)"></span>System
        Effect</span>
      <span class="legend-item"><span class="legend-dot"
          style="background:var(--node-safety-goal);border:1px solid var(--border-color)"></span>Safety Goal</span>
      <span class="legend-item"><span class="legend-dot" style="background:var(--node-safety-mechanism)"></span>Safety
        Mechanism</span>
      <span class="legend-hint">Drag nodes &bull; Scroll to zoom &bull; Hover for details</span>
    </div>
    <div class="graph-link-controls">
      <label class="toggle-switch-wrapper">
        <span class="toggle-switch">
          <input type="checkbox" [checked]="showUnlinkedComponents" (change)="toggleShowUnlinkedComponents()">
          <span class="toggle-slider"></span>
        </span>
        <span>Show unlinked components</span>
      </label>
      <label class="toggle-switch-wrapper">
        <span class="toggle-switch">
          <input type="checkbox" [checked]="graphLinkMode" (change)="toggleGraphLinkMode()">
          <span class="toggle-slider"></span>
        </span>
        <span>Link Mode</span>
      </label>
      <label *ngIf="graphLinkMode">
        <span>Relationship type</span>
        <select [(ngModel)]="graphLinkRelType" (ngModelChange)="onGraphRelTypeChanged()">
          <option value="CAUSES">CAUSES (FI &rarr; FE)</option>
          <option value="LEADS_TO">LEADS_TO (FE &rarr; SE)</option>
          <option value="VIOLATES">VIOLATES (SE &rarr; SG)</option>
          <option value="COVERED_BY">COVERED_BY (FI &rarr; SM)</option>
          <option value="COVERED_BY_LATENT">COVERED_BY_LATENT (FI &rarr; SM)</option>
          <option value="EXPERIENCES">EXPERIENCES (Comp &rarr; FI)</option>
        </select>
      </label>
      <span *ngIf="graphLinkSource" class="graph-link-status">
        Source: <strong>{{ graphLinkSource.id }}</strong> — click target
      </span>
    </div>
  </article>
  <article class="panel graph-canvas-panel">
    <aside *ngIf="graphLinkMode && graphRelationMeta" class="graph-side-panel left">
      <h3>
        <ng-container *ngIf="graphQuickCreatePane === 'source'; else srcPanelTitle">New {{
          graphTypeDisplayName(graphRelationMeta.sourceType) }}</ng-container>
        <ng-template #srcPanelTitle>Unconnected {{ graphTypeDisplayName(graphRelationMeta.sourceType) }}
          Nodes</ng-template>
      </h3>
      <p class="graph-side-count" *ngIf="graphQuickCreatePane !== 'source'">{{ graphUnconnectedSourceNodes.length }}
        remaining</p>
      <ng-container *ngIf="graphQuickCreatePane === 'source'; else sourceNodeList">
        <div class="graph-qc-wrap">
          <ng-container [ngSwitch]="graphRelationMeta.sourceType">
            <form *ngSwitchCase="'failure_effect'" [formGroup]="graphQcFailureEffectForm"
              (ngSubmit)="submitGraphQcFailureEffect()" class="graph-qc-form">
              <input type="text" formControlName="id" placeholder="ID (optional)" />
              <input type="text" formControlName="name" placeholder="Effect name *" />
              <select formControlName="systemEffectId">
                <option value="">No system effect</option>
                <option *ngFor="let se of systemEffects()" [value]="se.id">{{ se.id }} – {{ se.name }}</option>
              </select>
              <button type="submit">Create</button>
            </form>
            <form *ngSwitchCase="'system_effect'" [formGroup]="graphQcSystemEffectForm"
              (ngSubmit)="submitGraphQcSystemEffect()" class="graph-qc-form">
              <input type="text" formControlName="id" placeholder="ID (optional)" />
              <input type="text" formControlName="name" placeholder="Effect name *" />
              <select formControlName="safetyGoalId">
                <option value="">No safety goal</option>
                <option *ngFor="let sg of safetyGoals()" [value]="sg.id">{{ sg.id }} – {{ sg.description }}</option>
              </select>
              <button type="submit">Create</button>
            </form>
            <form *ngSwitchCase="'safety_goal'" [formGroup]="graphQcSafetyGoalForm"
              (ngSubmit)="submitGraphQcSafetyGoal()" class="graph-qc-form">
              <input type="text" formControlName="id" placeholder="ID (optional)" />
              <textarea formControlName="description" rows="3" placeholder="Description *"></textarea>
              <button type="submit">Create</button>
            </form>
            <form *ngSwitchCase="'safety_mechanism'" [formGroup]="graphQcSafetyMechanismForm"
              (ngSubmit)="submitGraphQcSafetyMechanism()" class="graph-qc-form">
              <input type="text" formControlName="smId" placeholder="ID (optional)" />
              <input type="text" formControlName="name" placeholder="Mechanism name *" />
              <select formControlName="mechanismType">
                <option value="SPF">Primary (SPF)</option>
                <option value="LATENT">Secondary (Latent)</option>
              </select>
              <input type="number" step="0.01" min="0" max="1" formControlName="diagnosticCoverage"
                placeholder="DC (0–1)" />
              <select formControlName="failureInstanceId">
                <option value="">No failure instance</option>
                <option *ngFor="let fi of failureInstances()" [value]="fi.id">{{ fi.id }} – {{ fi.name }}</option>
              </select>
              <button type="submit">Create</button>
            </form>
          </ng-container>
        </div>
        <button type="button" class="graph-qc-cancel" (click)="closeGraphPanelCreate()">Cancel</button>
      </ng-container>
      <ng-template #sourceNodeList>
        <ul #unconnectedSourceNodesContainer class="graph-side-list">
          <li *ngFor="let node of graphUnconnectedSourceNodes" [id]="'unconnected-source-node-' + node.id">
            <button type="button" class="graph-node-item" [class.selected-source]="isGraphPanelNodeSelected(node)"
              (click)="handleNodeClick(node, 'panel')" (contextmenu)="onGraphPanelNodeContextMenu($event, node)">
              <span class="graph-node-badge" [style.background]="typeColor(node.type)"
                [style.color]="typeTextColor(node.type)">
                {{ typeLabel(node.type) }}
              </span>
              <span class="graph-node-meta">
                <strong>{{ node.id }}</strong>
                <small>{{ node.label }}</small>
              </span>
            </button>
          </li>
          <li *ngIf="graphUnconnectedSourceNodes.length === 0" class="empty">All connected for this relation type.</li>
        </ul>
        <button *ngIf="graphQuickCreateEnabled(graphRelationMeta.sourceType)" type="button" class="graph-qc-btn"
          (click)="openGraphPanelCreate('source')">+</button>
      </ng-template>
    </aside>
    <div #graphContainer class="graph-container"></div>
    <aside *ngIf="graphLinkMode && graphRelationMeta" class="graph-side-panel right">
      <ng-container *ngIf="graphLinkSource as source; else defaultTargetPanel">
        <ng-container
          *ngIf="graphLinkRelType === 'EXPERIENCES' && source.type === 'component'; else defaultTargetPanel">
          <h3>Remaining Failure Modes for {{ source.id }}</h3>
          <p class="graph-side-count">{{ graphSelectedComponentRemainingFailureModeCount }} remaining</p>
          <ul class="graph-side-list">
            <li *ngFor="let mode of graphSelectedComponentRemainingFailureModes">
              <button type="button" class="graph-node-item target-mode" [class.linked]="mode.isLinked"
                [disabled]="mode.isLinked" (click)="createFailureInstanceFromMode(mode)">
                <span class="graph-node-badge" [style.background]="typeColor('failure_instance')"
                  [style.color]="typeTextColor('failure_instance')">
                  FM
                </span>
                <span class="graph-node-meta">
                  <strong>{{ mode.code }}</strong>
                  <small>{{ mode.name }} <ng-container *ngIf="mode.isLinked">(already linked)</ng-container></small>
                </span>
              </button>
            </li>
            <li *ngIf="graphSelectedComponentRemainingFailureModes.length === 0" class="empty">
              No failure modes defined for this component type.
            </li>
          </ul>
        </ng-container>
      </ng-container>

      <ng-template #defaultTargetPanel>
        <h3>
          <ng-container *ngIf="graphQuickCreatePane === 'target'; else tgtPanelTitle">New {{
            graphTypeDisplayName(graphRelationMeta.targetType) }}</ng-container>
          <ng-template #tgtPanelTitle>Unconnected {{ graphTypeDisplayName(graphRelationMeta.targetType) }}
            Nodes</ng-template>
        </h3>
        <p class="graph-side-count" *ngIf="graphQuickCreatePane !== 'target'">{{ graphUnconnectedTargetNodes.length }}
          remaining</p>
        <ng-container *ngIf="graphQuickCreatePane === 'target'; else targetNodeList">
          <div class="graph-qc-wrap">
            <ng-container [ngSwitch]="graphRelationMeta.targetType">
              <form *ngSwitchCase="'failure_effect'" [formGroup]="graphQcFailureEffectForm"
                (ngSubmit)="submitGraphQcFailureEffect()" class="graph-qc-form">
                <input type="text" formControlName="id" placeholder="ID (optional)" />
                <input type="text" formControlName="name" placeholder="Effect name *" />
                <select formControlName="systemEffectId">
                  <option value="">No system effect</option>
                  <option *ngFor="let se of systemEffects()" [value]="se.id">{{ se.id }} – {{ se.name }}</option>
                </select>
                <button type="submit">Create</button>
              </form>
              <form *ngSwitchCase="'system_effect'" [formGroup]="graphQcSystemEffectForm"
                (ngSubmit)="submitGraphQcSystemEffect()" class="graph-qc-form">
                <input type="text" formControlName="id" placeholder="ID (optional)" />
                <input type="text" formControlName="name" placeholder="Effect name *" />
                <select formControlName="safetyGoalId">
                  <option value="">No safety goal</option>
                  <option *ngFor="let sg of safetyGoals()" [value]="sg.id">{{ sg.id }} – {{ sg.description }}</option>
                </select>
                <button type="submit">Create</button>
              </form>
              <form *ngSwitchCase="'safety_goal'" [formGroup]="graphQcSafetyGoalForm"
                (ngSubmit)="submitGraphQcSafetyGoal()" class="graph-qc-form">
                <input type="text" formControlName="id" placeholder="ID (optional)" />
                <textarea formControlName="description" rows="3" placeholder="Description *"></textarea>
                <button type="submit">Create</button>
              </form>
              <form *ngSwitchCase="'safety_mechanism'" [formGroup]="graphQcSafetyMechanismForm"
                (ngSubmit)="submitGraphQcSafetyMechanism()" class="graph-qc-form">
                <input type="text" formControlName="smId" placeholder="ID (optional)" />
                <input type="text" formControlName="name" placeholder="Mechanism name *" />
                <select formControlName="mechanismType">
                  <option value="SPF">Primary (SPF)</option>
                  <option value="LATENT">Secondary (Latent)</option>
                </select>
                <input type="number" step="0.01" min="0" max="1" formControlName="diagnosticCoverage"
                  placeholder="DC (0–1)" />
                <select formControlName="failureInstanceId">
                  <option value="">No failure instance</option>
                  <option *ngFor="let fi of failureInstances()" [value]="fi.id">{{ fi.id }} – {{ fi.name }}</option>
                </select>
                <button type="submit">Create</button>
              </form>
            </ng-container>
          </div>
          <button type="button" class="graph-qc-cancel" (click)="closeGraphPanelCreate()">Cancel</button>
        </ng-container>
        <ng-template #targetNodeList>
          <ul #unconnectedTargetNodesContainer class="graph-side-list">
            <li *ngFor="let node of graphUnconnectedTargetNodes" [id]="'unconnected-target-node-' + node.id">
              <button type="button" class="graph-node-item" [class.selected-source]="isGraphPanelNodeSelected(node)"
                (click)="handleNodeClick(node, 'panel')" (contextmenu)="onGraphPanelNodeContextMenu($event, node)">
                <span class="graph-node-badge" [style.background]="typeColor(node.type)"
                  [style.color]="typeTextColor(node.type)">
                  {{ typeLabel(node.type) }}
                </span>
                <span class="graph-node-meta">
                  <strong>{{ node.id }}</strong>
                  <small>{{ node.label }}</small>
                </span>
              </button>
            </li>
            <li *ngIf="graphUnconnectedTargetNodes.length === 0" class="empty">All connected for this relation type.
            </li>
          </ul>
          <button *ngIf="graphQuickCreateEnabled(graphRelationMeta.targetType)" type="button" class="graph-qc-btn"
            (click)="openGraphPanelCreate('target')">+</button>
        </ng-template>
      </ng-template>
    </aside>
  </article>

</div>